import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { CartContext } from "../cart/ContextProvider";
import "./orderDetail.css";
import { useNavigate } from "react-router";
import Loader from '../common/Loader';

function OrderPage() {
    const { userId } = useContext(CartContext);
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get("https://jackpotbackend.vercel.app/orderDetails", {
                    params: {
                        userId: userId
                    }
                });
                // Sort the orders in descending order based on created_at field
                const sortedOrders = response.data.orders.sort((a, b) => b.created_at - a.created_at);
                setOrders(sortedOrders);
                console.log(sortedOrders);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching orders:", error);
                setLoading(false);
            }
        };

        fetchData(); // Call the async function
    }, [userId]); // Include userId in the dependency array to re-fetch orders when it changes

    function handleClick(order) {
        navigate('/orderItems', { state: order });
    }

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <div className="orderPage">
                    <p className="Heading">Your Orders</p>
                    <div className="orders-container">
                        {orders.map((order, index) => (
                            <div className="order-card" key={index}>
                                <div onClick={() => handleClick(order)} className="order-details">
                                    <p><strong>Order ID:</strong> {order.id}</p>
                                    <p><strong>Amount Paid:</strong> {(order.amount_paid / 100).toFixed(2)}</p>
                                    <p><strong>Currency:</strong> {order.currency}</p>
                                    <p><strong>No of Items:</strong> {order.items.length}</p>
                                    <p><strong>Status:</strong> {order.status}</p>
                                    <p><strong>Created At:</strong> {new Date(order.created_at * 1000).toLocaleString()}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
}

export default OrderPage;
